import { Question } from '@thesisedu/feature-assignments-core'

export const QUESTION_DEFAULTS: Partial<Question> = {
  config: {},
  weight: 0,
}
